import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ApiPageResponse, PageQuery } from '../types/api.types';
import { VehicleOption } from '../types/option.types';

@Injectable({ providedIn: 'root' })
export class OptionsService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.gatewayUrl}/rental/api/options`;

  /** Liste paginée du référentiel des options. Utilisé en lecture seule côté
   *  owner pour alimenter le picker d'équipements de la fiche véhicule. */
  list(query: PageQuery = {}): Observable<ApiPageResponse<VehicleOption>> {
    let params = new HttpParams()
      .set('pageable', 'true')
      .set('page', String(query.page ?? 1))
      .set('size', String(query.size ?? 200))
      .set('isDeleted', String(query.isDeleted ?? false));
    if (query.search?.trim()) params = params.set('search', query.search.trim());
    return this.http.get<ApiPageResponse<VehicleOption>>(this.base, { params });
  }
}
